import PolicyPage from '../components/PolicyPage';

const RefundPolicyPage = () => {
  return (
    <PolicyPage 
      title="Refund Policy"
      metaTitle="Refund Policy - Payment & Cancellation Guidelines"
      metaDescription="Review the refund policy for Golden Tree Events services. Covers payment terms, cancellation deadlines, refund processing timelines, and conditions for event registration refunds."
      sourceUrl="https://gtedubai.com/app/refund-policy?awd=gte"
    />
  );
};

export default RefundPolicyPage;
